var isReactClassish = require('./isReactClassish');

function isReactElementish(obj, React) {
  if (!obj) {
    return false;
  }

  return Object.prototype.toString.call(obj.props) === '[object Object]' &&
         isReactClassish(obj.type, React);
}

module.exports = isReactElementish;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hot-loader/isReactElementish.js
 ** module id = 120
 ** module chunks = 0
 **/